import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { SeatFill, SeatOutline } from '@lyearn/icons';
import { useAdminRoute } from '@/pages/corporate/routes/hooks/useAdminRoutes';
import { EventStatusEnum } from '@/types/schema';

import InformationBox from '../InformationBox';
import { SeatsLeftProps } from './types';

const SeatsLeft: React.FC<SeatsLeftProps> = ({
  className,
  isFillingFast = false,
  seatLimit,
  isRegistrationRequired,
  isUserRegistered,
  status,
  isRegistrationOpen,
  usersCount = 0,
  color,
}) => {
  const { isMobile } = useScreen();
  const { t } = useTranslation('Events');
  const isAdminRoute = useAdminRoute();
  const showSeatsLeft =
    seatLimit &&
    isRegistrationRequired &&
    !isUserRegistered &&
    status !== EventStatusEnum.Completed;

  if (!showSeatsLeft) {
    return null;
  }

  const seatsLeft = seatLimit - usersCount;
  const isSeatsLeft = (isRegistrationOpen || isAdminRoute) && seatsLeft > 0;

  if (!isSeatsLeft) {
    return (
      <InformationBox
        Icon={SeatFill}
        className={className}
        color={{ icon: 'icon-placeholder', text: 'text-text-secondary' }}
        content={t('Events:NoSeatsLeft')}
        variant={isMobile ? 'body-short-01' : 'body-short-02'}
      />
    );
  }

  return (
    <InformationBox
      Icon={SeatOutline}
      className={className}
      color={{
        icon: isFillingFast ? 'icon-warning-light' : color?.icon,
        text: color?.text,
      }}
      content={
        isMobile
          ? t('Events:ShortSeatsLeft', { count: seatsLeft })
          : t('Events:SeatsLeft', { count: seatsLeft })
      }
      variant={isMobile ? 'body-short-01' : 'body-short-02'}
    />
  );
};

export default SeatsLeft;
